'use client';

import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Join The Club',
    description: 'No fees for a limited time.',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  {
    number: '02',
    title: 'Browse & Choose',
    description: 'Explore our curated collection of ultra luxury cruises. From Mediterranean escapes to Antarctic expeditions.',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    ),
  },
  {
    number: '03',
    title: 'Hold Your Cabin',
    description: 'Select and hold your preferred cabin at the advertised price. Absolutely nothing to pay and no obligation to proceed with the cruise.',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    number: '04',
    title: 'Receive Your Discount',
    description: 'We apply your exclusive members only discount and send an updated confirmation. Effortless savings, every time.',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
      </svg>
    ),
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-28 bg-cream-light relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-cream-dark/30 to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-10 bg-gold" />
            <span className="text-gold text-xs tracking-[0.3em] uppercase font-light">The Process</span>
          </div>
          <h2 className="font-serif text-navy-dark text-4xl md:text-5xl font-light leading-tight max-w-lg">
            How Your Membership{' '}
            <span className="italic text-primary">Works</span>
          </h2>
        </div>

        {/* Uniform 4-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 border border-cream-dark rounded-sm overflow-hidden">
          {steps?.map((step, index) => (
            <div
              key={step?.number}
              className={`relative p-10 flex flex-col group bg-white hover:bg-navy-dark transition-colors duration-500 ${
                index < steps?.length - 1 ? 'border-r border-cream-dark' : ''
              }`}
            >
              {/* Step number watermark */}
              <div className="text-navy-dark/5 group-hover:text-white/5 font-serif text-7xl font-light absolute bottom-4 right-5 leading-none select-none transition-colors duration-500">
                {step?.number}
              </div>

              {/* Gold top accent line */}
              <div className="absolute top-0 left-0 w-full h-px bg-gold opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative z-10 flex flex-col h-full">
                {/* Icon */}
                <div className="w-11 h-11 rounded-sm bg-navy-dark/5 group-hover:bg-gold/15 flex items-center justify-center text-navy group-hover:text-gold mb-6 transition-colors duration-500">
                  {step?.icon}
                </div>

                {/* Step label */}
                <span className="text-gold text-xs tracking-[0.25em] uppercase font-light mb-3">
                  Step {step?.number}
                </span>

                {/* Title */}
                <h3 className="font-serif text-navy-dark group-hover:text-white text-xl font-light mb-3 transition-colors duration-500">
                  {step?.title}
                </h3>

                {/* Description */}
                <p className="text-navy-dark/50 group-hover:text-white/60 text-sm font-light leading-relaxed transition-colors duration-500">
                  {step?.description}
                </p>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
